import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'ws-scripts/modules/common';
import { setClassNames } from 'ddc-classnames-js';
import { triggerExpandReviewEvent } from '../utilities/analytics';
import Truncate from './Truncate';

import '../global-sass/main.scss';

const ReadMore = (props) => {
	const [expanded, setExpanded] = useState(false);
	const [truncated, setTruncate] = useState(false);
	const { useHorizontalStyle, useInverseTextColor } = usePrefs();
	const enableHorizontalLayout = useHorizontalStyle === 'true';

	const handleTruncate = (truncat) => {
		if (truncated !== truncat) {
			setTruncate(truncat);
		}
	};

	const toggleLines = (
		event,
		element,
		elementCTA,
		result,
		windowId,
		widgetName
	) => {
		event.preventDefault();
		triggerExpandReviewEvent(
			element,
			elementCTA,
			result,
			windowId,
			widgetName
		);
		setExpanded(!expanded);
	};

	const { children, more, less, lines, windowId, widgetName, labels } = props;

	const textColor = useInverseTextColor === 'true' ? 'text-inverse' : '';

	let textLinkColor = '';
	if (useInverseTextColor === 'true') {
		textLinkColor = enableHorizontalLayout
			? 'text-muted-inverse'
			: 'text-link-inverse';
	} else if (enableHorizontalLayout) {
		textLinkColor = 'text-muted';
	}

	const readMoreLinkClasses = [
		'read-more-link',
		'text-link',
		'd-block',
		textLinkColor,
		enableHorizontalLayout ? 'text-decoration-underline' : ''
	];

	return (
		<div className="review-body">
			<Truncate
				className={textColor}
				lines={!expanded && lines}
				ellipsis={
					<span>
						&hellip;{' '}
						<button
							className={setClassNames(readMoreLinkClasses)}
							onClick={(event) => {
								toggleLines(
									event,
									'Read more link',
									more,
									'Review expanded',
									windowId,
									widgetName
								);
							}}
							type="button"
						>
							{labels.get(more)}
						</button>
					</span>
				}
				onTruncate={handleTruncate}
			>
				{children}
			</Truncate>
			{!truncated && expanded && (
				<span>
					{' '}
					<button
						className={setClassNames(readMoreLinkClasses)}
						onClick={(event) => {
							toggleLines(
								event,
								'Read less link',
								less,
								'Review collapsed',
								windowId,
								widgetName
							);
						}}
						type="button"
					>
						{labels.get(less)}
					</button>
				</span>
			)}
		</div>
	);
};
ReadMore.defaultProps = {
	lines: 2,
	more: 'READ_MORE',
	less: 'SHOW_LESS'
};

ReadMore.propTypes = {
	children: PropTypes.node.isRequired,
	more: PropTypes.string,
	less: PropTypes.string,
	lines: PropTypes.number,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired
};

export default ReadMore;
